import { render, staticRenderFns } from "./phoneTable.vue?vue&type=template&id=38c112b5&scoped=true&"
import script from "./phoneTable.vue?vue&type=script&lang=js&"
export * from "./phoneTable.vue?vue&type=script&lang=js&"
import style0 from "./phoneTable.vue?vue&type=style&index=0&id=38c112b5&scoped=true&lang=scss&ref=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c112b5",
  null
  
)

export default component.exports